export class OpenDialog {
  static readonly type = '[Report dialog] Open dialog';
}

export class CloseDialog {
  static readonly type = '[Report dialog] Close dialog';
}
